import React, {useState, useEffect} from 'react'
import {Container, Modal,Button, Row, Col, Form} from 'react-bootstrap';
import styles from './popup.module.css';

import { Checkbox, FormControlLabel} from '@mui/material';
import cover from '../../assets/imgs/cover.png'
export const Popup = () => {

    const [show, setShow] = useState(false);
  
    const handleClose = () => setShow(false);
    useEffect(()=>{
      setTimeout(()=>{
        setShow(true);
      }, 3000);
    }, []);

  return (
  <div>
   
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        className={`${styles.modal}`}
      >
        <Modal.Header closeButton className={`${styles.titlebar}`}>
          <Modal.Title className={`border-0 ${styles.title}`}>Free Instgram Hacks.</Modal.Title>
        </Modal.Header>
        <Row>
       
       <Col xs={12} sm={12} lg={6} md={6}>
       <Modal.Body>
       <img src={cover} alt='ads' className={`border-0 img-fluid ${styles.img}`} />
       </Modal.Body>
       </Col>
       <Col xs={12} sm={12} lg={6} md={6}>
       <Modal.Body>
         <p className={`border-0 ${styles.text}`}>Looking to start selling on instagram? Our FREE 2022 playbook is chock full of tips to guide your sucess.</p>
       <Form className={`border-0 ${styles.form}`}>
         <Form.Control type='email' name='email' placeholder='Enter Mail' className={`border-0 ${styles.formC}`}/>
         <Button variant='primary' type='submit' className={`border-0 ${styles.btn}`}>Submit</Button>
       {/* <Form.Check type='checkbox' label='I consent to recieve e-mail from Ullweb.' className={`mt-2 ${styles.check}`}/> */}
  <FormControlLabel 
      className={`${styles.check}`}

  control ={<Checkbox
    //  {...label}
      defaultChecked
      label='he'
      sx={{
        color:'#404494',
        '&.Mui-checked':{
          color: '#404494'
,        }
      }} />
    }
    label='I consent to recieve e-mail from Ullweb.' />
       </Form>
       </Modal.Body>

       </Col>
      </Row>

      </Modal>
    </div>
  );
 }